import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const { user, login } = useAuth();

  const handleGetStarted = () => {
    if (user) {
      navigate('/interviews');
    } else {
      login(); // This will trigger the OAuth flow
    }
  };

  return (
    <div className="home-container">
      <h1 className="home-title">AI-Powered Product Management Mock Interview Platform</h1>
      <p className="home-description">
        Prepare for your product management interviews with our AI-driven platform. 
        Experience realistic mock interviews, receive instant feedback, and enhance your skills 
        to ace your next big opportunity.
      </p>
      <button className="get-started-button" onClick={handleGetStarted}>
        Get Started
      </button>
      <div className="feature-section">
        <div className="feature">
          <h3>Realistic Mock Interviews</h3>
          <p>Practice with scenarios designed to mirror real-world product management challenges.</p>
        </div>
        <div className="feature">
          <h3>Instant Feedback</h3>
          <p>Receive immediate insights and recommendations to improve your performance.</p>
        </div>
        <div className="feature">
          <h3>Skill Enhancement</h3>
          <p>Develop critical product management skills to secure your next big opportunity.</p>
        </div>
      </div>
    </div>
  );
};

export default Home;